'use strict';

var _ = require('lodash');
var ChartDashboardPerformanceLegendController = function ChartDashboardPerformanceLegendController($scope, $rootScope, userPreferencesService, configurationService) {
  var defaultCogOptions = require('../config/cogOptions.json');
  var defaultCogElement = userPreferencesService.getUserSettingComponent('defaultPerformanceChart') || defaultCogOptions.defaults['no-submenu']['no-group'][0];
  $scope.cogOptions = _.cloneDeep(defaultCogOptions);
  $scope.cabinOptions = configurationService.getDisplayableCabins();
  $scope.setDefaultState = function () {
    var currentCogOption = $scope.cogOptions.defaults['no-submenu']['no-group'][0];
    if (currentCogOption !== defaultCogElement) {
      $scope.cogOptions = _.clone(defaultCogOptions);
      $rootScope.$broadcast('cog:market-performance-chart', {
        val: [defaultCogElement]
      });
    }
  };
  $scope.updateCogOptions = function (event, data) {
    $scope.cogOptions.defaults['no-submenu']['no-group'] = data.val;
  };
  $scope.isLoadFactorMetric = function () {
    return $scope.screenState.selectedMetric.id === 'loadFactor';
  };
  $scope.getProperSeasonLabel = function () {
    return $scope.isLoadFactorMetric() ? 'Overbooking' : 'Demand';
  };
};
ChartDashboardPerformanceLegendController.$inject = ['$scope', '$rootScope', 'UserPreferencesService', 'ConfigurationService'];
module.exports = ChartDashboardPerformanceLegendController;